<template>
  <div class="main">
    <div class="form">
      <a-form-model
        layout="inline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-form-model-item label="操作：">
          <a-select style="width: 200px" v-model="formInline.act">
            <a-select-option v-for="item in api" :key="item.path">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="操作人：">
          <a-input placeholder="请输入操作人" v-model="formInline.user">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="id：">
          <a-input
            placeholder="请输入要查找的文章id或者栏目id"
            v-model="formInline.word"
            style="width:250px"
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" html-type="submit">
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>

      <a-table
        :columns="columns"
        :dataSource="list"
        :pagination="pagination"
        :rowKey="record => record.id"
        @change="handleTableChange"
        :loading="loading"
        style="margin-top:30px"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: '日志编号',
    dataIndex: 'id',
    width: 150,
    scopedSlots: { customRender: 'id' },
    align: 'center'
  },

  {
    title: '操作人',
    dataIndex: 'user',
    scopedSlots: { customRender: 'user' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'type',
    width: 600,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '操作时间',
    dataIndex: 'addtime',
    scopedSlots: { customRender: 'addtime' },
    align: 'center'
  }
];
export default {
  data() {
    return {
      columns,
      api: [
        { title: '删除云稿件', id: 0, path: 'api/content/clouddel' },
        {
          title: '云稿栏目排序',
          id: 1,
          path: 'api/content/cloudcategoryorder'
        },
        { title: '栏目排序', id: 2, path: 'api/content/categorylistorder' },
        { title: '删除栏目', id: 3, path: 'api/content/categorydel' },
        { title: '更新/添加栏目', id: 4, path: 'api/content/categoryupdate' }
      ],
      formInline: {
        act: 'api/content/clouddel',
        user: '',
        word: '',
        page: 1
      },
      loading: false,
      list: [],
      pagination: {
        pageSize: 20
      }
    };
  },
  methods: {
    handleSubmit(e) {
      this.formInline.page = 1;
      this.getLogs(this.formInline);
    },
    getLogs(param) {
      this.loading = true;
      this.$http
        .post('http://cn3xapi.ycrmt.cn/fusionMedia/log/index', param)
        .then(res => {
          const pagination = { ...this.pagination };
          if (res.data.errno === 0) {
            this.list = res.data.data.data;
            pagination.total = res.data.data.total;
          } else {
            pagination.total = 0;
            this.list = [];
          }
          this.loading = false;
          this.pagination = pagination;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.formInline.page = pager.current;
      this.getLogs(this.formInline);
    }
  },
  created() {
    this.getLogs(this.formInline);
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.screen-option {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
